import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5724 15.7397C21.35 15.0512 21.1061 14.3698 20.8411 13.6965L19.8553 11.2634C19.8553 11.2352 19.8683 10.7564 19.8683 10.5094C19.8683 6.34831 17.8825 2.16663 13 2.16663C8.11737 2.16663 6.13162 6.34831 6.13162 10.5083C6.13162 10.7564 6.14355 11.2352 6.14462 11.2634L5.1588 13.6966C4.89429 14.37 4.65043 15.0514 4.42755 15.7397C3.49587 18.7048 3.79812 19.9322 4.0278 19.9593C4.52071 20.0178 5.94637 17.7276 5.94637 17.7276C5.94637 19.0536 6.63646 20.7848 8.13037 22.035C7.57246 22.2051 6.8878 22.4672 6.44687 22.7879C6.05146 23.0771 6.1013 23.3729 6.1728 23.4921C6.48587 24.0131 11.5407 23.8246 13.001 23.6621C14.4603 23.8246 19.5162 24.0131 19.8282 23.491C19.8997 23.3718 19.9495 23.0771 19.5541 22.7879C19.1132 22.4672 18.4285 22.2051 17.8695 22.0339C19.3635 20.7848 20.0535 19.0536 20.0535 17.7266C20.0535 17.7266 21.4792 20.0178 21.9721 19.9582C22.2018 19.9311 22.503 18.7048 21.5713 15.7397"
      fill="#308FFF"
    />
  </svg>
);
export default SVGComponent;
